export default "__VITE_ASSET__Bzgw9vUJ__"